






import bulmaCalendar from 'bulma-calendar';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class CommandDisplay extends Vue {
  @Prop({ required: false })
  public clear?: boolean;

  public calendars: any;
  public startDate: Date = new Date(new Date().valueOf() - 1000 * 60 * 60 * 8);
  public calendarOptions: any = {
    minDate: new Date('2019-7-1'),
    maxDate: new Date(),
    startDate: this.startDate,
    isRange: true,
    showHeader: false,
    showFooter: false,
    showClearButton: false,
    labelFrom: 'Start Time',
    labelTo: 'End Time',
    type: 'date',
    showButtons: false,
  };

  public mounted() {
    this.calendars = bulmaCalendar.attach('#date-picker', this.calendarOptions);

    this.calendars[0].on('select', (calendar: any) => {
      this.$emit('datePicked', calendar.data.date);
    });
  }

  @Watch('clear')
  public onDisplayParamsChanged(val: any) {
    this.calendars[0].clear();
  }
}
